module.exports = __webpack_public_path__ + "img/ai-block-editor-img.5509546a.png";